export function restoreScriptTags(state) {
  let stateText = JSON.stringify(state);
  stateText = stateText.replace(/<_script_/g, '<script').replace(/<\/_script_>/g, '</script>');
  return JSON.parse(stateText);
}
